/* eslint-disable max-lines */
export const LANGUAGES = {
    '1C Enterprise': {
        color: '#814CCC',
    },
    ABAP: {
        color: '#E8274B',
    },
    'AGS Script': {
        color: '#B9D9FF',
    },
    AMPL: {
        color: '#E6EFBB',
    },
    ANTLR: {
        color: '#9DC3FF',
    },
    'API Blueprint': {
        color: '#2ACCA8',
    },
    APL: {
        color: '#5A8164',
    },
    ASP: {
        color: '#6a40fd',
    },
    ATS: {
        color: '#1ac620',
    },
    ActionScript: {
        color: '#882B0F',
    },
    Ada: {
        color: '#02f88c',
    },
    Agda: {
        color: '#315665',
    },
    Alloy: {
        color: '#64C800',
    },
    AngelScript: {
        color: '#C7D7DC',
    },
    Apex: {
        color: '#179CD7',
    },
    AppleScript: {
        color: '#101F1F',
    },
    Arc: {
        color: '#aa2afe',
    },
    AspectJ: {
        color: '#a957b0',
    },
    Assembly: {
        color: '#6E4C13',
    },
    AutoHotkey: {
        color: '#6594b9',
    },
    AutoIt: {
        color: '#1C3552',
    },
    Ballerina: {
        color: '#FF5000',
    },
    Batchfile: {
        color: '#C1F12E',
    },
    Blade: {
        color: '#228B22',
    },
    BlitzMax: {
        color: '#cd6400',
    },
    Boo: {
        color: '#d4bec1',
    },
    Brainfuck: {
        color: '#2F2530',
    },
    C: {
        color: '#555555',
    },
    'C#': {
        color: '#6A1577',
    },
    'C++': {
        color: '#f34b7d',
    },
    CSS: {
        color: '#563d7c',
    },
    CSV: {
        color: '#1d6f42',
    },
    Ceylon: {
        color: '#dfa535',
    },
    Chapel: {
        color: '#8dc63f',
    },
    Cirru: {
        color: '#ccccff',
    },
    Clarion: {
        color: '#db901e',
    },
    Clean: {
        color: '#3F85AF',
    },
    Click: {
        color: '#E4E6F3',
    },
    Clojure: {
        color: '#db5855',
    },
    CoffeeScript: {
        color: '#244776',
    },
    ColdFusion: {
        color: '#ed2cd6',
    },
    'Common Lisp': {
        color: '#3fb68b',
    },
    'Common Workflow Language': {
        color: '#B5314C',
    },
    'Component Pascal': {
        color: '#B0CE4E',
    },
    'Composer JSON': {
        color: '#7A7DBD',
    },
    Crystal: {
        color: '#776791',
    },
    Cuda: {
        color: '#3A4E3A',
    },
    D: {
        color: '#ba595e',
    },
    DM: {
        color: '#447265',
    },
    Dart: {
        color: '#00B4AB',
    },
    DataWeave: {
        color: '#003a52',
    },
    Dockerfile: {
        color: '#0db7ed',
    },
    Dogescript: {
        color: '#cca760',
    },
    Dylan: {
        color: '#6c616e',
    },
    E: {
        color: '#ccce35',
    },
    ECL: {
        color: '#8a1267',
    },
    EQ: {
        color: '#a78649',
    },
    Eiffel: {
        color: '#946d57',
    },
    Elixir: {
        color: '#6e4a7e',
    },
    Elm: {
        color: '#60B5CC',
    },
    'Emacs Lisp': {
        color: '#c065db',
    },
    EmberScript: {
        color: '#FFF4F3',
    },
    Erlang: {
        color: '#B83998',
    },
    'F#': {
        color: '#b845fc',
    },
    'F*': {
        color: '#572e30',
    },
    FLUX: {
        color: '#88ccff',
    },
    Factor: {
        color: '#636746',
    },
    Fancy: {
        color: '#7b9db4',
    },
    Fantom: {
        color: '#14253c',
    },
    Forth: {
        color: '#341708',
    },
    Fortran: {
        color: '#4d41b1',
    },
    FreeMarker: {
        color: '#0050b2',
    },
    Frege: {
        color: '#00cafe',
    },
    GDScript: {
        color: '#355570',
    },
    'Game Maker Language': {
        color: '#71b417',
    },
    Genie: {
        color: '#fb855d',
    },
    Gherkin: {
        color: '#5B2063',
    },
    Glyph: {
        color: '#c1ac7f',
    },
    Gnuplot: {
        color: '#f0a9f0',
    },
    Go: {
        color: '#29BEB0',
    },
    Golo: {
        color: '#88562A',
    },
    Gosu: {
        color: '#82937f',
    },
    Gradle: {
        color: '#02303A',
    },
    'Grammatical Framework': {
        color: '#79aa7a',
    },
    GraphQL: {
        color: '#ff79c6',
    },
    Groovy: {
        color: '#e69f56',
    },
    HCL: {
        color: '#623CE4',
    },
    HTML: {
        color: '#e34c26',
    },
    'HTML+Django': {
        color: '#092E20',
    },
    'HTML+ERB': {
        color: '#570000',
    },
    'HTML+PHP': {
        color: '#6164A4',
    },
    Hack: {
        color: '#2E3171',
    },
    Haml: {
        color: '#ecdfa7',
    },
    Harbour: {
        color: '#0e60e3',
    },
    Haskell: {
        color: '#5e5086',
    },
    Haxe: {
        color: '#df7900',
    },
    HiveQL: {
        color: '#dce200',
    },
    Hy: {
        color: '#7790B2',
    },
    IDL: {
        color: '#a3522f',
    },
    Idris: {
        color: '#b30000',
    },
    Io: {
        color: '#a9188d',
    },
    Ioke: {
        color: '#078193',
    },
    Isabelle: {
        color: '#FEFE00',
    },
    J: {
        color: '#9EEDFF',
    },
    JSON: {
        color: '#BEAD27',
    },
    'JSON with Comments': {
        color: '#BEAD27',
    },
    JSON5: {
        color: '#BEAD27',
    },
    JSONLD: {
        color: '#BEAD27',
    },
    JSONiq: {
        color: '#40d47e',
    },
    JSX: {
        color: '#D8C741',
    },
    Java: {
        color: '#b07219',
    },
    JavaScript: {
        color: '#f1e05a',
    },
    Jolie: {
        color: '#843179',
    },
    Julia: {
        color: '#a270ba',
    },
    'Jupyter Notebook': {
        color: '#DA5B0B',
    },
    KRL: {
        color: '#28430A',
    },
    Kotlin: {
        color: '#F18E33',
    },
    LFE: {
        color: '#4C3023',
    },
    LLVM: {
        color: '#185619',
    },
    LOLCODE: {
        color: '#cc9900',
    },
    LSL: {
        color: '#3d9970',
    },
    Lasso: {
        color: '#999999',
    },
    Latte: {
        color: '#8F674C',
    },
    Less: {
        color: '#5C8624',
    },
    Lex: {
        color: '#DBCA00',
    },
    LiveScript: {
        color: '#499886',
    },
    LookML: {
        color: '#652B81',
    },
    Lua: {
        color: '#000080',
    },
    MAXScript: {
        color: '#00a6a6',
    },
    MQL4: {
        color: '#62A8D6',
    },
    MQL5: {
        color: '#4A76B8',
    },
    MTML: {
        color: '#b7e1f4',
    },
    Makefile: {
        color: '#427819',
    },
    Markdown: {
        color: '#696969',
    },
    Mask: {
        color: '#f97732',
    },
    Matlab: {
        color: '#e16737',
    },
    Max: {
        color: '#c4a79c',
    },
    Mercury: {
        color: '#ff2b2b',
    },
    Meson: {
        color: '#007800',
    },
    Metal: {
        color: '#8f14e9',
    },
    Mirah: {
        color: '#c7a938',
    },
    'Modula-3': {
        color: '#223388',
    },
    NCL: {
        color: '#28431f',
    },
    Nearley: {
        color: '#990000',
    },
    Nemerle: {
        color: '#3d3c6e',
    },
    NetLinx: {
        color: '#0aa0ff',
    },
    'NetLinx+ERB': {
        color: '#747faa',
    },
    NetLogo: {
        color: '#ff6375',
    },
    NewLisp: {
        color: '#87AED7',
    },
    Nextflow: {
        color: '#3ac486',
    },
    Nim: {
        color: '#37775b',
    },
    Nit: {
        color: '#009917',
    },
    Nix: {
        color: '#7e7eff',
    },
    'npm JSON': {
        color: '#BEAD27',
    },
    Nu: {
        color: '#c9df40',
    },
    OCaml: {
        color: '#3be133',
    },
    'Objective-C': {
        color: '#438eff',
    },
    'Objective-C++': {
        color: '#6866fb',
    },
    'Objective-J': {
        color: '#ff0c5a',
    },
    Omgrofl: {
        color: '#cabbff',
    },
    Opal: {
        color: '#f7ede0',
    },
    Oxygene: {
        color: '#cdd0e3',
    },
    Oz: {
        color: '#fab738',
    },
    P4: {
        color: '#7055b5',
    },
    PAWN: {
        color: '#dbb284',
    },
    PHP: {
        color: '#474A8A',
    },
    PLSQL: {
        color: '#dad8d8',
    },
    PLpgSQL: {
        color: '#CB7400',
    },
    Pan: {
        color: '#cc0000',
    },
    Papyrus: {
        color: '#6600cc',
    },
    Parrot: {
        color: '#f3ca0a',
    },
    Pascal: {
        color: '#E3F171',
    },
    Pep8: {
        color: '#C76F5B',
    },
    Perl: {
        color: '#0298c3',
    },
    'Perl 6': {
        color: '#0000fb',
    },
    PigLatin: {
        color: '#fcd7de',
    },
    Pike: {
        color: '#005390',
    },
    PogoScript: {
        color: '#d80074',
    },
    PostScript: {
        color: '#da291c',
    },
    PowerBuilder: {
        color: '#8f0f8d',
    },
    PowerShell: {
        color: '#012456',
    },
    Processing: {
        color: '#0096D8',
    },
    Prolog: {
        color: '#74283c',
    },
    'Propeller Spin': {
        color: '#7fa2a7',
    },
    Puppet: {
        color: '#302B6D',
    },
    PureBasic: {
        color: '#5a6986',
    },
    PureScript: {
        color: '#1D222D',
    },
    Python: {
        color: '#4B8BBE',
    },
    QML: {
        color: '#44a51c',
    },
    Quake: {
        color: '#882233',
    },
    R: {
        color: '#198CE7',
    },
    RAML: {
        color: '#77d9fb',
    },
    RDoc: {
        color: '#8A2F30',
    },
    RUNOFF: {
        color: '#665a4e',
    },
    Racket: {
        color: '#22228f',
    },
    Ragel: {
        color: '#9d5200',
    },
    Rascal: {
        color: '#fffaa0',
    },
    Rebol: {
        color: '#358a5b',
    },
    Red: {
        color: '#f50000',
    },
    "Ren'Py": {
        color: '#ff7f7f',
    },
    Ring: {
        color: '#2D54CB',
    },
    Roff: {
        color: '#ecdebe',
    },
    Rouge: {
        color: '#cc0088',
    },
    Ruby: {
        color: '#701516',
    },
    Rust: {
        color: '#dea584',
    },
    SAS: {
        color: '#B34936',
    },
    SCSS: {
        color: '#CF649A',
    },
    SQF: {
        color: '#3F3F3F',
    },
    SQL: {
        color: '#E48D00',
    },
    SQLPL: {
        color: '#CB7400',
    },
    'SRecode Template': {
        color: '#348a34',
    },
    Svelte: {
        color: '#FF3E00',
    },
    SVG: {
        color: '#FFA500',
    },
    SaltStack: {
        color: '#646464',
    },
    Sass: {
        color: '#CF649A',
    },
    Scala: {
        color: '#c22d40',
    },
    Scheme: {
        color: '#1e4aec',
    },
    Self: {
        color: '#0579aa',
    },
    Shell: {
        color: '#89e051',
    },
    Shen: {
        color: '#120F14',
    },
    Slash: {
        color: '#007eff',
    },
    Smalltalk: {
        color: '#596706',
    },
    Solidity: {
        color: '#AA6746',
    },
    SourcePawn: {
        color: '#5c7611',
    },
    Squirrel: {
        color: '#800000',
    },
    Stan: {
        color: '#b2011d',
    },
    'Standard ML': {
        color: '#dc566d',
    },
    SuperCollider: {
        color: '#46390b',
    },
    Swift: {
        color: '#ffac45',
    },
    SystemVerilog: {
        color: '#DAE1C2',
    },
    'TI Program': {
        color: '#A0AA87',
    },
    Tcl: {
        color: '#e4cc98',
    },
    TeX: {
        color: '#3D6117',
    },
    Terra: {
        color: '#00004c',
    },
    Turing: {
        color: '#cf142b',
    },
    Twig: {
        color: '#5C8624',
    },
    TypeScript: {
        color: '#2b7489',
    },
    UnrealScript: {
        color: '#a54c4d',
    },
    VCL: {
        color: '#148AA8',
    },
    VHDL: {
        color: '#adb2cb',
    },
    Vala: {
        color: '#fbe5cd',
    },
    Verilog: {
        color: '#b2b7f8',
    },
    'Vim script': {
        color: '#199f4b',
    },
    'Visual Basic': {
        color: '#945db7',
    },
    Volt: {
        color: '#1F1F1F',
    },
    Vue: {
        color: '#2c3e50',
    },
    WebAssembly: {
        color: '#04133b',
    },
    X10: {
        color: '#4B6BEF',
    },
    XC: {
        color: '#99DA07',
    },
    XQuery: {
        color: '#5232e7',
    },
    XSLT: {
        color: '#EB8CEB',
    },
    YASnippet: {
        color: '#32AB90',
    },
    Yacc: {
        color: '#4B6C4B',
    },
    Zephir: {
        color: '#118f9e',
    },
    eC: {
        color: '#913960',
    },
    nesC: {
        color: '#94B0C7',
    },
    ooc: {
        color: '#b0b77e',
    },
    q: {
        color: '#0040cd',
    },
    sed: {
        color: '#64b970',
    },
    wdl: {
        color: '#42f1f4',
    },
    wisp: {
        color: '#7582D1',
    },
    xBase: {
        color: '#403a40',
    },
};
